import PropTypes from 'prop-types';

import CallToActionContainer from '@/components/common/callToAction/CallToActionContainer';

import styles from './PrimeurUserNoData.module.scss';

export const PrimeurUserNoData = ({ img, alt, text, onClick, labelBtn }) => (
  <div className={styles.container} data-rbf={`no-data-${alt}`}>
    <div className={styles.icon}>
      <img
        src={img}
        alt={alt}
        height={48}
        width={48}
      />
    </div>
    <p className={styles.text}>{text}</p>
    {labelBtn &&
      <CallToActionContainer
        onClick={() => onClick()}
        className={styles.subscribe}
      >
        {labelBtn}
      </CallToActionContainer>
    }
  </div>
);

PrimeurUserNoData.propTypes = {
  img: PropTypes.string,
  alt: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func,
  labelBtn: PropTypes.string,
};

export default PrimeurUserNoData;
